import React from "react";
import classes from "./UserTable.module.css";
import { formatEditAt } from "../../utils/editAudit";

const UserTable = ({
  data,
  setShow,
  setUser,
  onRequestDelete,
  deleteLoading,
}) => {
  return (
    <table className={`table table-striped table-hover ${classes.table}`}>
      <thead>
        <tr className={"table-dark " + classes.thead}>
          <th className="col-md">Full name</th>
          <th className="col-md">Email</th>
          <th className="col-md">Registration Date</th>
          <th className="col-md">Last Edit</th>
          <th className="col-md ">Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr key={item.id || item.email}>
            <td className="col-md">{item.name}</td>
            <td className="col-md">{item.email}</td>
            <td className="col-md">{item.registration_time}</td>
            <td className={`col-md ${classes.lastEdit}`}>
              {item.last_edit_ip || item.last_edit_location || item.last_edit_by ? (
                <>
                  <div>{item.last_edit_ip || "—"}</div>
                  <div>{item.last_edit_location || "—"}</div>
                  {item.last_edit_by && <div>by {item.last_edit_by}</div>}
                  {item.last_edit_at && <div>{formatEditAt(item.last_edit_at)}</div>}
                  {item.last_edit_action && <div>{item.last_edit_action}</div>}
                </>
              ) : (
                "—"
              )}
            </td>
            <td className="col-md">
              <button
                className={"btn btn-outline-primary m-1"}
                disabled={deleteLoading}
                onClick={() => {
                  setUser(item);
                  setShow(true);
                }}
              >
                Edit
              </button>
              <button
                className="btn btn-outline-danger m-1"
                disabled={deleteLoading}
                onClick={() => onRequestDelete(item)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default UserTable;
